import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
  Layout,
  Breadcrumb,
  Form,
  Input,
  Modal,
  Select,
  Button,
  Table,
  message,
  notification,
  Skeleton,
  Divider,
  Checkbox,
} from 'antd';

import { DragDropContext, DragSource, DropTarget } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import update from 'immutability-helper';
import _ from 'lodash';
import styles from './styles.module.scss';
import whttp from '../../libs/whttp';
import { API_HOST, Role, GOOGLE_MAP_KEY } from '../../configs/env';
import AppHelper from 'libs/AppHelper';

import { genFormItemAtrribute } from 'libs/FormHelper';

import Errors from 'validatorjs/src/errors';
import ValidatorErrorAlert from '../../components/ValidatorErrorAlert/ValidatorErrorAlert';

const Option = Select.Option;

const devNewsInfo = {
  user_id: '',
  privileges: {},
};
function ImageSize(category) {
  //大Banner
  if (category == 50) return '建議尺寸: 1440 x 640';
  //中Banner
  else if (category == 53) return '建議尺寸: 1200 x 600';
  //美食購物, 品牌列表 Banner
  else if (category == 54 || category == 110) return '建議尺寸: 1080 x 400';
  //活動消息
  else
    return '封面建議尺寸: 1200 x 600 (2:1) ; 內頁建議尺寸: 最小寬度1080以上即可';
}

const privilegeOptions = [
  { keyPath: 'news', value: true, name: '最新消息' },
  // { keyPath: 'life', value: true, name: '生活專欄' },
  { keyPath: 'categories', value: true, name: '類別管理' },
  { keyPath: 'catalogues', value: true, name: '促銷目錄管理' },
  { keyPath: 'recipes', value: true, name: '食譜管理' },
  { keyPath: 'deliveries', value: true, name: '第三方平台管理' },
  { keyPath: 'cibc', value: true, name: '保經據點管理' },
  { keyPath: 'privileges', value: true, name: '權限管理' },
  { keyPath: ['brands', 'create'], value: true, name: '新增品牌' },
  { keyPath: ['brands', 'modify'], value: true, name: '編輯品牌' },
  { keyPath: ['stores', 'create'], value: true, name: '新增分店' },
  { keyPath: 'static', value: true, name: '靜態頁面轉換' },
  { keyPath: 'hotkeywords', value: true, name: '熱門關鍵字' },
];
@DragDropContext(HTML5Backend)
export default class NewsInfo extends Component {
  formRef = React.createRef();

  state = {
    storeOptions: [],
    privilegeInfo: {
      id: null,
      status: 1,
      name: null,
      logo: null,
      type: 1,
      action_type: 0,
      category_id: null,
      is_middle_banner: 0,
    },
    data: [],
    messages: {},
    isFetchData: false,
    isSubmitData: false,
    cate: null,
    cateName: null,
  };

  componentDidMount() {
    AppHelper.updateConfig();
    this.loadStoresData();
    this.fetchData();
    this.fillData();
  }

  fillData = (data = _.cloneDeep(devNewsInfo)) => {
    console.log('fill', data);
    if (!this.formRef.current) return;

    // 處理資料，本地適合Form Control的資料
    // data.show_range = [_.get(data, 'show_at') ? moment(_.get(data, 'show_at')) : null, _.get(data, 'show_at') ? moment(_.get(data, 'hide_at')) : null]
    // data.date_range = [moment(_.get(data, 'start_date')), moment(_.get(data, 'end_date'))]

    // if (!_.isBoolean(data.status)) data.status = data.status === 1
    // if (!_.isBoolean(data.is_middle_banner)) data.is_middle_banner = data.is_middle_banner === 1
    // _.map(data.images,(item,idx)=>{
    //   if(item.path==null||item.url==null){data.images.splice(idx, 1);}
    // })
    this.formRef.current.setFieldsValue(data);
  };
  // 拉Table資料
  loadStoresData = (opt = { page: 1, page_size: 10 }) => {
    const { table_query } = this.state;
    const tableQuery = this.formRef.current.getFieldValue();
    const { page, page_size } = opt;

    this.setState({ isLoadingData: true });

    whttp.get(
      API_HOST + '/api/mgt/v1/stores',
      {
        page: page,
        page_size: 'all',
        keyword: _.get(tableQuery, 'keyword'),
        // group: _.get(tableQuery, 'store_group_id'),
        // area: _.get(tableQuery, 'store_area_id'),
        // store_type: _.get(tableQuery, 'store_type_id'),
      },
      (state, res) => {
        this.setState({ isLoadingData: false });
        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          return this.setState({ message: '發生錯誤' });
        }

        if (code !== 200) {
          return this.setState({ message: reason });
        }

        this.setState({ storeOptions: _.get(data, 'rows', []) });
      }
    );
  };
  // 抓取頁面資訊
  fetchData = () => {
    const id = _.get(this, 'props.match.params.id');
    console.log(_.get(this, 'props.match.params'));
    if (!id) return;

    this.setState({ isFetchData: true });
    whttp.get(API_HOST + `/api/mgt/v1/privileges/${id}`, null, (state, res) => {
      this.setState({ isFetchData: false });

      const { code = 100, reason = '發生錯誤', data = {} } = res;

      console.log(code, reason, data, res);

      if (state === false || code !== 200) {
        message.warning(reason);
        this.props.history.replace('/privileges');
        return;
      }

      this.fillData(data);
    });
  };

  submitData = (privilegeInfo = {}) => {
    // 把Control元件轉換回上傳資料
    privilegeInfo.user_id = _.get(this, 'props.match.params.id');
    // privilegeInfo.cover = _.get(privilegeInfo,'cover.path')
    // privilegeInfo.show_at    = _.get(privilegeInfo, 'show_range.0').format('YYYY-MM-DD HH:mm:ss')
    // privilegeInfo.hide_at    = _.get(privilegeInfo, 'show_range.1').format('YYYY-MM-DD HH:mm:ss')
    // privilegeInfo.start_date = _.get(privilegeInfo, 'date_range.0').format('YYYY-MM-DD')
    // privilegeInfo.end_date   = _.get(privilegeInfo, 'date_range.1').format('YYYY-MM-DD')
    // privilegeInfo.category_id = this.getFieldValue('category_id')
    //privilegeInfo.is_middle_banner = this.getFieldValue('is_middle_banner')
    // if(this.getFieldValue('category_id') == 53)
    // {
    //   privilegeInfo.is_middle_banner = 1;
    // }
    //delete privilegeInfo.show_range
    //delete privilegeInfo.date_range
    console.log('submitData', privilegeInfo);
    const id = _.get(this, 'props.match.params.id', '');

    this.setState({ isSubmitData: true, messages: {} });

    whttp.post(
      API_HOST + `/api/mgt/v1/privileges/${id}`,
      privilegeInfo,
      (state, res) => {
        console.log(state, res);
        this.setState({ isSubmitData: false });

        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          return message.error('發生錯誤');
        }

        if (code !== 200) {
          notification['error']({
            message: '更新失敗',
            description: reason,
          });
          const messages = data.messages;
          if (_.isObject(messages)) {
            //處理錯誤訊息
            _.map(messages, (errors, key) => {
              console.log('map', key, errors);
              return {
                touched: true,
                validating: false,
                errors: [],
                name: [key],
                value: this.getFieldValue(key),
              };
            });
            this.forceUpdate();
            console.log('this.formRef.current', this.formRef.current);
          }
          return this.setState({ messages: data.messages || {} });
        }

        message.success('更新成功');

        this.fillData(data);
      }
    );
  };
  deleteData = (item) => {
    if (_.isNil(item.id)) return;
    item.isDeleteData = true;
    this.setState({ isDeleteData: true });

    whttp.delete(
      API_HOST + `/api/mgt/v1/privileges/${item.id}`,
      {},
      (state, res) => {
        item.isDeleteData = false;
        this.setState({ isDeleteData: false });
        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          return message.error('發生錯誤');
        }

        if (code !== 200) {
          return message.error(reason);
        }

        message.success('刪除成功');

        this.loadData();
      }
    );
  };

  cloneData = (item) => {
    if (_.isNil(item.id)) return;

    item.isCloneData = true;

    this.setState({ isCloneData: true });

    whttp.post(
      API_HOST + `/api/mgt/v1/privileges/${item.id}/clone`,
      {},
      (state, res) => {
        item.isCloneData = false;
        this.setState({ isCloneData: false });
        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          return message.error('發生錯誤');
        }

        if (code !== 200) {
          return message.error(reason);
        }

        message.success('複製成功');

        if (!_.isNil(data.id))
          this.props.history.push(`/privileges/view/${data.id}`);
      }
    );
  };
  getImages = () => {
    return this.formRef.current &&
      _.isArray(this.formRef.current.getFieldValue('images'))
      ? this.formRef.current.getFieldValue('images')
      : [];
  };
  moveRow = (dragIndex, hoverIndex) => {
    const { table_data = {}, table_data: { rows = [] } = {} } = this.state;
    let images = this.getImages();
    const dragRow = images[dragIndex];

    images = update(images, {
      $splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
    });

    this.formRef.current.setFields([
      {
        touched: true,
        validating: false,
        errors: [],
        name: ['images'],
        value: images,
      },
    ]);
  };

  getFieldValue = (key, defaultValue = undefined) => {
    return this.formRef.current
      ? this.formRef.current.getFieldValue(key)
      : defaultValue;
  };

  enterNotSubmit = (e) => {
    if (e.key === 'Enter') {
      let value = e.target + '';
      if (value.indexOf('TextArea') !== -1) {
        console.log('TextArea');
      } else e.preventDefault();
    }
  };

  render() {
    // 登入使用者的權限
    const errors = _.get(this, 'state.validator.errors', new Errors());
    const editorPermissions = _.get(this.props, 'auth.permissions', {});
    const options = _.get(this, 'props.app.options', {});
    const pdf = this.getFieldValue('pdf');
    const id = _.get(this, 'props.match.params.id');
    const category_id = this.getFieldValue('category_id');
    const storeOptions = _.get(this, 'state.storeOptions');
    window.getFieldValue = this.getFieldValue;

    //const privilegeInfo
    return (
      <Layout className={styles.container}>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to={`/privileges`}>權限管理</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>權限</Breadcrumb.Item>
        </Breadcrumb>

        <h2>
          權限
          <span />
        </h2>

        <ValidatorErrorAlert errors={errors} />

        <Skeleton loading={this.state.isFetchData}>
          <div className='block search'>
            <Form
              ref={this.formRef}
              name='basic'
              className='basicForm'
              layout='vertical'
              onFinish={(values) => this.submitData(values)}
              onKeyDown={(e) => {
                this.enterNotSubmit(e);
              }}
              onFieldsChange={(changedFields, allFields) => {
                console.log('onFieldsChange', changedFields, allFields);
              }}
              onValuesChange={(changedFields, allFields) => {
                console.log(
                  'onValuesChange',
                  this.getFieldValue('stores'),
                  changedFields
                );
              }}
            >
              <Form.Item
                style={{ textAlign: 'right' }}
                taillayout={{ wrapperCol: { offset: 8, span: 16 } }}
              >
                <Button
                  type='primary'
                  htmlType='submit'
                  style={{ marginLeft: 8 }}
                  loading={this.state.isSubmitData}
                >
                  儲存
                </Button>
              </Form.Item>

              <div className='flexBox'>
                <Form.Item {...genFormItemAtrribute('user_id', 'Username')}>
                  <Input defaultValue='Username' disabled />
                </Form.Item>
              </div>

              <Divider>權限管理</Divider>

              {_.map(privilegeOptions, (item) => {
                return (
                  <Form.Item
                    {...genFormItemAtrribute(
                      _.isString(item.keyPath)
                        ? ['privileges', item.keyPath]
                        : ['privileges', ...item.keyPath]
                    )}
                    valuePropName='checked'
                    noStyle
                  >
                    <Checkbox value={item.value}>{item.name}</Checkbox>
                  </Form.Item>
                );
              })}
              <div className='flexBox' />

              <Divider>分店管理</Divider>
              <Form.List name={['privileges', 'stores', 'modify']}>
                {(fields, { add, remove, move }) => {
                  return (
                    <Fragment>
                      {fields.length > 0 && (
                        <Table
                          pagination={false}
                          rowKey={(item, idx) => idx}
                          dataSource={fields}
                          components={{
                            body: {
                              row: DragableBodyRow,
                            },
                          }}
                          onRow={(record, index) => ({
                            index,
                            moveRow: (dragIndex, hoverIndex) =>
                              move(dragIndex, hoverIndex),
                          })}
                          columns={[
                            {
                              dataIndex: 'id',
                              title: '#',
                              render: (id, item, idx) => (
                                <Form.Item>{idx + 1}</Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'name',
                              title: '名稱',
                              render: (name, item, idx) => (
                                <Form.Item
                                  {...genFormItemAtrribute(idx)}
                                  rules={[
                                    { required: true, message: '請填寫名稱' },
                                  ]}
                                >
                                  <Select
                                    showSearch
                                    style={{ width: 200 }}
                                    placeholder='輸入店名'
                                    optionFilterProp='children'
                                    // onChange={onChange}
                                    // onFocus={onFocus}
                                    // onBlur={onBlur}
                                    // onSearch={onSearch}
                                    filterOption={(input, option) => {
                                      console.log(
                                        'filterOption',
                                        input,
                                        option
                                      );
                                      return (
                                        option.children
                                          .toLowerCase()
                                          .indexOf(input.toLowerCase()) >= 0
                                      );
                                    }}
                                  >
                                    <Option value='all'>全部</Option>
                                    {_.map(storeOptions, (store) => (
                                      <Option value={store.id} data={store}>
                                        {store.name}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'name',
                              title: 'Action',
                              render: (name, item, idx) => (
                                <Form.Item>
                                  <Button danger onClick={() => remove(idx)}>
                                    刪除
                                  </Button>
                                </Form.Item>
                              ),
                            },
                          ]}
                        />
                      )}
                      <Button onClick={() => add()}>新增</Button>
                    </Fragment>
                  );
                }}
              </Form.List>
            </Form>
          </div>

          <Modal
            visible={this.state.previewImage}
            footer={null}
            onCancel={() => this.setState({ previewImage: null })}
          >
            <img
              alt='Preview'
              style={{ width: '100%' }}
              src={this.state.previewImage && this.state.previewImage.url}
            />
          </Modal>
        </Skeleton>
      </Layout>
    );
  }
}

/* DnD */
let dragingIndex = -1;

class BodyRow extends React.Component {
  render() {
    const {
      isOver,
      connectDragSource,
      connectDropTarget,
      moveRow,
      ...restProps
    } = this.props;
    const style = { ...restProps.style, cursor: 'move' };

    let className = restProps.className;
    if (isOver) {
      if (restProps.index > dragingIndex) {
        className += ' drop-over-downward';
      }
      if (restProps.index < dragingIndex) {
        className += ' drop-over-upward';
      }
    }

    return connectDragSource(
      connectDropTarget(
        <tr {...restProps} className={className} style={style} />
      )
    );
  }
}

const rowSource = {
  beginDrag(props) {
    dragingIndex = props.index;
    return {
      index: props.index,
    };
  },
};

const rowTarget = {
  drop(props, monitor) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Time to actually perform the action
    props.moveRow(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  },
};

const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
}))(
  DragSource('row', rowSource, (connect) => ({
    connectDragSource: connect.dragSource(),
  }))(BodyRow)
);

/* DnD */



// WEBPACK FOOTER //
// ./src/views/Privilege/PrivilegeInfo.js